import * as $runtime from "../runtime.js";
import * as Control$dApplicative$dFree from "../Control.Applicative.Free/index.js";
import * as Control$dMonad$dFree from "../Control.Monad.Free/index.js";
import * as Control$dParallel from "../Control.Parallel/index.js";
import * as Data$dCoyoneda from "../Data.Coyoneda/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dException from "../Effect.Exception/index.js";
import * as Effect$dRef from "../Effect.Ref/index.js";
import * as Halogen$dQuery$dHalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Halogen$dQuery$dHalogenQ from "../Halogen.Query.HalogenQ/index.js";
import * as Halogen$dQuery$dInput from "../Halogen.Query.Input/index.js";
import * as Halogen$dSubscription from "../Halogen.Subscription/index.js";
import * as Unsafe$dReference from "../Unsafe.Reference/index.js";
const traverse_ = /* #__PURE__ */ Data$dFoldable.traverse_(Effect.applicativeEffect)(Data$dFoldable.foldableMaybe);
const lookup = k => {
  const go = go$a0$copy => {
    let go$a0 = go$a0$copy, go$c = true, go$r;
    while (go$c) {
      const v = go$a0;
      if (v.tag === "Leaf") {
        go$c = false;
        go$r = Data$dMaybe.Nothing;
        continue;
      }
      if (v.tag === "Node") {
        const v1 = Data$dOrd.ordInt.compare(k)(v._3);
        if (v1 === "LT") {
          go$a0 = v._5;
          continue;
        }
        if (v1 === "GT") {
          go$a0 = v._6;
          continue;
        }
        if (v1 === "EQ") {
          go$c = false;
          go$r = Data$dMaybe.$Maybe("Just", v._4);
          continue;
        }
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go;
};
const traverse_1 = /* #__PURE__ */ Data$dFoldable.traverse_(Effect$dAff.applicativeAff);
const traverse_2 = /* #__PURE__ */ traverse_1(Data$dList$dTypes.foldableList);
const parSequence_ = /* #__PURE__ */ Control$dParallel.parTraverse_(Effect$dAff.parallelAff)(Effect$dAff.applicativeParAff)(Data$dList$dTypes.foldableList)(Control$dParallel.identity);
const traverse_3 = /* #__PURE__ */ traverse_1(Data$dFoldable.foldableMaybe);
const lookup1 = k => {
  const go = go$a0$copy => {
    let go$a0 = go$a0$copy, go$c = true, go$r;
    while (go$c) {
      const v = go$a0;
      if (v.tag === "Leaf") {
        go$c = false;
        go$r = Data$dMaybe.Nothing;
        continue;
      }
      if (v.tag === "Node") {
        const v1 = Data$dOrd.ordInt.compare(k)(v._3);
        if (v1 === "LT") {
          go$a0 = v._5;
          continue;
        }
        if (v1 === "GT") {
          go$a0 = v._6;
          continue;
        }
        if (v1 === "EQ") {
          go$c = false;
          go$r = Data$dMaybe.$Maybe("Just", v._4);
          continue;
        }
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go;
};
const lookup2 = k => {
  const go = go$a0$copy => {
    let go$a0 = go$a0$copy, go$c = true, go$r;
    while (go$c) {
      const v = go$a0;
      if (v.tag === "Leaf") {
        go$c = false;
        go$r = Data$dMaybe.Nothing;
        continue;
      }
      if (v.tag === "Node") {
        const v1 = Data$dOrd.ordString.compare(k)(v._3);
        if (v1 === "LT") {
          go$a0 = v._5;
          continue;
        }
        if (v1 === "GT") {
          go$a0 = v._6;
          continue;
        }
        if (v1 === "EQ") {
          go$c = false;
          go$r = Data$dMaybe.$Maybe("Just", v._4);
          continue;
        }
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go;
};
const foldFree = /* #__PURE__ */ Control$dMonad$dFree.foldFree(Effect$dAff.monadRecAff);
const alter = /* #__PURE__ */ Data$dMap$dInternal.alter(Data$dOrd.ordString);
const unsubscribe = sid => ref => () => {
  const v = ref.value;
  const subs = v.subscriptions.value;
  return traverse_(Halogen$dSubscription.unsubscribe)((() => {
    const $0 = lookup(sid);
    if (subs.tag === "Just") { return $0(subs._1); }
    if (subs.tag === "Nothing") { return Data$dMaybe.Nothing; }
    $runtime.fail();
  })())();
};
const queueOrRun = ref => au => Effect$dAff._bind(Effect$dAff._liftEffect(() => ref.value))(v => {
  if (v.tag === "Nothing") { return au; }
  if (v.tag === "Just") { return Effect$dAff._liftEffect(() => ref.value = Data$dMaybe.$Maybe("Just", Data$dList$dTypes.$List("Cons", au, v._1))); }
  $runtime.fail();
});
const handleLifecycle = lchs => f => Effect$dAff._bind(Effect$dAff._liftEffect(() => lchs.value = {initializers: Data$dList$dTypes.Nil, finalizers: Data$dList$dTypes.Nil}))(() => Effect$dAff._bind(Effect$dAff._liftEffect(f))(result => Effect$dAff._bind(Effect$dAff._liftEffect(() => lchs.value))(v => {
  const $0 = v.initializers;
  return Effect$dAff._bind(traverse_2(Effect$dAff.forkAff)(v.finalizers))(() => Effect$dAff._bind(parSequence_($0))(() => Effect$dAff._pure(result)));
})));
const handleAff = /* #__PURE__ */ Effect$dAff.runAff_(v2 => {
  if (v2.tag === "Left") { return Effect$dException.throwException(v2._1); }
  if (v2.tag === "Right") { return () => {}; }
  $runtime.fail();
});
const fresh = f => ref => Effect$dAff._bind(Effect$dAff._liftEffect(() => ref.value))(v => Effect$dAff._liftEffect(Effect$dRef.modifyImpl(i => ({state: i + 1 | 0, value: f(i)}))(v.fresh)));
const evalQ = render => ref => q => Effect$dAff._bind(Effect$dAff._liftEffect(() => ref.value))(v => evalM(render)(ref)(v.component.eval(Halogen$dQuery$dHalogenQ.$HalogenQ(
  "Query",
  Data$dCoyoneda.$CoyonedaF(x => Data$dMaybe.$Maybe("Just", x), q),
  v$1 => Data$dMaybe.Nothing
))));
const evalM = render => initRef => v => foldFree(v1 => {
  if (v1.tag === "State") {
    return Effect$dAff._bind(Effect$dAff._liftEffect(() => initRef.value))(v2 => {
      const v3 = v1._1(v2.state);
      if (Unsafe$dReference.reallyUnsafeRefEq(v2.state)(v3._2)) { return Effect$dAff._pure(v3._1); }
      const $0 = v3._1;
      return Effect$dAff._bind(Effect$dAff._liftEffect((() => {
        const $1 = {...v2, state: v3._2};
        return () => initRef.value = $1;
      })()))(() => Effect$dAff._bind(handleLifecycle(v2.lifecycleHandlers)(render(v2.lifecycleHandlers)(initRef)))(() => Effect$dAff._pure($0)));
    });
  }
  if (v1.tag === "Subscribe") {
    return Effect$dAff._bind(fresh(Halogen$dQuery$dHalogenM.SubscriptionId)(initRef))(sid => Effect$dAff._bind(Effect$dAff._liftEffect(v1._1(sid)(x => {
      const $0 = handleAff(evalF(render)(initRef)(Halogen$dQuery$dInput.$Input("Action", x)));
      return () => {$0();};
    })))(finalize => Effect$dAff._bind(Effect$dAff._liftEffect(() => initRef.value))(v2 => Effect$dAff._bind(Effect$dAff._liftEffect((() => {
      const $0 = Data$dMap$dInternal.insert(Data$dOrd.ordInt)(sid)(finalize);
      const $1 = v2.subscriptions;
      return () => {
        const $2 = $1.value;
        $1.value = $2.tag === "Just" ? Data$dMaybe.$Maybe("Just", $0($2._1)) : Data$dMaybe.Nothing;
      };
    })()))(() => Effect$dAff._pure(v1._2(sid))))));
  }
  if (v1.tag === "Unsubscribe") {
    const $0 = v1._2;
    return Effect$dAff._bind(Effect$dAff._liftEffect(unsubscribe(v1._1)(initRef)))(() => Effect$dAff._pure($0));
  }
  if (v1.tag === "Lift") { return v1._1; }
  if (v1.tag === "ChildQuery") {
    const $0 = v1._1;
    return Effect$dAff._bind(Effect$dAff._liftEffect(() => initRef.value))(v1$1 => {
      const $1 = $0._2;
      return Effect$dAff._map($0._3)(Effect$dAff._sequential($0._1(Effect$dAff.applicativeParAff)(v3 => Effect$dAff._bind(Effect$dAff._liftEffect(() => v3.value))(dsx => evalQ(render)(dsx.selfRef)($1)))(v1$1.children)));
    });
  }
  if (v1.tag === "Raise") {
    const $0 = v1._2;
    const $1 = v1._1;
    return Effect$dAff._bind(Effect$dAff._liftEffect(() => initRef.value))(v2 => {
      const $2 = v2.handlerRef;
      const $3 = v2.pendingOuts;
      return Effect$dAff._bind(Effect$dAff._liftEffect(() => $2.value))(handler => Effect$dAff._bind(queueOrRun($3)(handler($1)))(() => Effect$dAff._pure($0)));
    });
  }
  if (v1.tag === "Par") {
    return Effect$dAff._sequential(Control$dApplicative$dFree.foldFreeAp(Effect$dAff.applicativeParAff)(Control$dApplicative$dFree.identity)((() => {
      const $0 = evalM(render)(initRef);
      return Control$dApplicative$dFree.foldFreeAp(Control$dApplicative$dFree.applicativeFreeAp)(x => Control$dApplicative$dFree.$FreeAp("Lift", $0(x)))(v1._1);
    })()));
  }
  if (v1.tag === "Fork") {
    const $0 = v1._1;
    return Effect$dAff._bind(fresh(Halogen$dQuery$dHalogenM.ForkId)(initRef))(fid => Effect$dAff._bind(Effect$dAff._liftEffect(() => initRef.value))(v2 => {
      const $1 = v2.forks;
      return Effect$dAff._bind(Effect$dAff._liftEffect(() => ({value: false})))(doneRef => Effect$dAff._bind(Effect$dAff.forkAff(Effect$dAff.finally(Effect$dAff._liftEffect((() => {
        const $2 = Data$dMap$dInternal.delete(Data$dOrd.ordInt)(fid);
        return () => {
          const $3 = $1.value;
          $1.value = $2($3);
          return doneRef.value = true;
        };
      })()))(evalM(render)(initRef)($0))))(fiber => Effect$dAff._bind(Effect$dAff._liftEffect((() => {
        const $2 = Data$dMap$dInternal.insert(Data$dOrd.ordInt)(fid)(fiber);
        return () => {
          const b = doneRef.value;
          if (!b) {
            const $3 = $1.value;
            $1.value = $2($3);
            return;
          }
          if (b) { return; }
          $runtime.fail();
        };
      })()))(() => Effect$dAff._pure(v1._2(fid)))));
    }));
  }
  if (v1.tag === "Join") {
    const $0 = v1._2;
    const $1 = v1._1;
    return Effect$dAff._bind(Effect$dAff._liftEffect(() => initRef.value))(v2 => {
      const $2 = v2.forks;
      return Effect$dAff._bind(Effect$dAff._liftEffect(() => $2.value))(forkMap => Effect$dAff._bind(traverse_3(Effect$dAff.joinFiber)(lookup1($1)(forkMap)))(() => Effect$dAff._pure($0)));
    });
  }
  if (v1.tag === "Kill") {
    const $0 = v1._2;
    const $1 = v1._1;
    return Effect$dAff._bind(Effect$dAff._liftEffect(() => initRef.value))(v2 => {
      const $2 = v2.forks;
      return Effect$dAff._bind(Effect$dAff._liftEffect(() => $2.value))(forkMap => Effect$dAff._bind(traverse_3(Effect$dAff.killFiber(Effect$dException.error("Cancelled")))(lookup1($1)(forkMap)))(() => Effect$dAff._pure($0)));
    });
  }
  if (v1.tag === "GetRef") {
    const $0 = v1._1;
    return Effect$dAff._bind(Effect$dAff._liftEffect(() => initRef.value))(v2 => Effect$dAff._pure(v1._2(lookup2($0)(v2.refs))));
  }
  $runtime.fail();
})(v);
const evalF = render => ref => v => {
  if (v.tag === "RefUpdate") {
    const $0 = v._2;
    const $1 = v._1;
    return Effect$dAff._liftEffect(() => {
      const $2 = ref.value;
      ref.value = {...$2, refs: alter(v$1 => $0)($1)($2.refs)};
    });
  }
  if (v.tag === "Action") {
    const $0 = v._1;
    return Effect$dAff._bind(Effect$dAff._liftEffect(() => ref.value))(v1 => evalM(render)(ref)(v1.component.eval(Halogen$dQuery$dHalogenQ.$HalogenQ("Action", $0, undefined))));
  }
  $runtime.fail();
};
export {
  alter,
  evalF,
  evalM,
  evalQ,
  foldFree,
  fresh,
  handleAff,
  handleLifecycle,
  lookup,
  lookup1,
  lookup2,
  parSequence_,
  queueOrRun,
  traverse_,
  traverse_1,
  traverse_2,
  traverse_3,
  unsubscribe
};
